import { connect, ConnectedProps } from 'react-redux'
import { ReduxState } from 'store/createRootReducer'
import * as actions from '../../actions'
import * as selectors from '../../selectors'

const mapStateToProps = (state: ReduxState) => {
  return {
    topCampaignsRateReport: selectors.topCampaignsRateReportSelector(state),
    error: selectors.errorSelector(state),
    isLoading: selectors.isLoadingSelector(state, 'isTopCampaignsRateLoading')
  }
}

const mapDispatchToProps = {
  fetchTopCampaignsRateReport: actions.fetchTopCampaignsRateReport
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type PropsFromRedux = ConnectedProps<typeof connector>
